module.exports = __webpack_public_path__ + "img/htht.77249f32.png";